// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3qkwE","label":"LabeledBox_label__15KD9"};